import {
  BOOKADD,
  BOOKDELETE,
  BOOKEDIT,
  BOOKLOADED,
  BOOKUPDATE
} from "./actionTypes";
import { initialState } from "./initialState";

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case BOOKLOADED:
      const {books, filterStatus} = action.payload
      return {
        ...state,
        books: [...books],
        filterFeatured: filterStatus,
      };
    case BOOKADD:
      return {
        ...state,
        books: [...state.books, action.payload],
      };
    case BOOKEDIT:
      return {
        ...state,
        editData: action.payload,
      };
    case BOOKUPDATE:
      const {updatedBook, featuredStatus} = action.payload;
      return {
        ...state,
        books: state.books.map(item=>{
          if (item.id !== updatedBook.id){
            return item
          }else{
            return {...item, ...updatedBook}
          }
        }),
        editData: {},
        filterFeatured: false, 
      };
    case BOOKDELETE:
      return {
        ...state,
        books: state.books.filter((book) => book.id !== action.payload),
      };
    default:
      return state;
  }
}
